
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import "./ScheduleInterview.scss";
import CardSection from "../../../components/ui/card/CardSection";
import useDebounce from "../../../app/customHooks/useDebounce";
import MyInterviewList from "../../../features/myInterview/component/MyInterviewList";
import AllInterviewList from "../../../features/allInterview/AllInterviewList";
import { IsAuthorizeUser } from "../../../lib/authenticationLibrary";

const ScheduleInterview = () => {
    const [search, setSearch] = useState("");
    const debouncedSearch = useDebounce(search, 300);
    // const defaultActiveTab = IsAuthorizeUser([1, 2]) !== undefined ? 1 : 0;
    const [activeTab, setActiveTab] = useState(0);

    const tabs = [
        {
            title: "All Interview",
            id: 1,
            component: <AllInterviewList search={debouncedSearch} />,
            Role: [1, 2, 3],
        },
        {
            title: "My Interview",
            id: 2,
            component: <MyInterviewList search={debouncedSearch} />,
            Role: [3],
        },
        // Add more tabs as needed
    ];

    const handleTabChange = (index) => {
        setActiveTab(index);
    };

    const handleChange = (event) => {
        const value = event.target.value;
        setSearch(value.trim());
    };

    return (
        <div className="candidate-list-b-none">
            <CardSection
                cardTitle="Schedule Interview"
                searchInput={true}
                searchInputName="Search By User Name"
                handleChange={handleChange}
            >
                <div className="tab-section ScheduleInterview-list-tab">
                    {/* Tabs Button Start */}
                    <div className="tab-header">
                        {tabs.map((tab, index) => (
                            IsAuthorizeUser(tab.Role) !== undefined ? (
                                <button
                                    key={tab.id}
                                    className={activeTab === index ? "active" : ""}
                                    onClick={() => handleTabChange(index)}
                                >
                                    {tab.title}
                                </button>
                            ) : null
                        ))}
                    </div>
                    {/* Tabs Button End */}

                    {/* Active Tabs Component Start */}
                    <div className="tab-content">
                        {activeTab !== -1 && (
                            <div className="tab-body-section">
                                {tabs[activeTab].component}
                            </div>
                        )}
                    </div>
                    {/* Active Tabs Component End */}
                </div>
            </CardSection>
        </div>
    );
};

export default ScheduleInterview;
